"use client";


function DismissibleBadge({
  className,
  children,
  color,
  open,
  toggleOpen,
}: DismissibleBadgePropsType) {
  return (
    <div className=" flex justify-center">
      {" "}
      <div
        onClick={toggleOpen}
        className={`relative font-semibold justify-center flex items-center  max-h-[50px]  cursor-pointer text-[15px] lg:text-[2.5rem] py-0  text-[#fff] transition-all  ${className}  ${
          !open ? "text-primary w-fit border-b-2 " : "rounded-[1000px] px-7 "
        } `}
        style={{
          background: open ? color : "#f0f8ff00",
        }}
      >
        <>
          <svg
            className={`cursor-pointer  rounded-full border border-white absolute flex items-center p-[2px] h-[2.37rem] w-[2.37rem] lg:h-[1.37rem] lg:w-[1.375rem]  justify-center bg-yellow-300 ease-in-out duration-75  top-[-11px] lg:top-[-0.6rem] left-1/2 transform transition-[top] -translate-x-1/2   ${
              !open && "opacity-0 text-white"
            }`}
            style={{
              background: color,
            }}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          {children}
        </>
      </div>
    </div>
  );
}

export default DismissibleBadge;
export type DismissibleBadgePropsType = {
  children?: JSX.Element | string;
  className?: string;
  color?: string;
  open?: boolean;
  toggleOpen?: () => void;
};
